import { render, staticRenderFns } from "./TypographyFamily.vue?vue&type=template&id=99264b6c&"
import script from "./TypographyFamily.vue?vue&type=script&lang=js&"
export * from "./TypographyFamily.vue?vue&type=script&lang=js&"
import style0 from "./TypographyFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports